module.exports = __webpack_public_path__ + "img/518.7cb3bf41.jpg";